import { render, staticRenderFns } from "./RegistroSintesiPers.vue?vue&type=template&id=7bfd394b"
import script from "./RegistroSintesiPers.vue?vue&type=script&lang=js"
export * from "./RegistroSintesiPers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports